import { ValidatorFn } from '@angular/forms/src/directives/validators';
import { Mask } from '../mask.interface';
import { Validation } from '../validation.interface';
import { FormControl } from '@angular/forms';

export class CPFModel implements Mask, Validation {

  static CPF = 'cpf';
  static CPF_ERROR_DESCRIPTION = 'CPF inválido';
  private cpfMask = [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];

  static CPFValidation(input: FormControl) {
    let _cpf;
    let sum = 0;
    let rest;
    if (input.value === '' || input.value === undefined) {
      return { [CPFModel.CPF]: true, description: 'Null or undefined' };
    }

    try {
      _cpf = input.value.replace(/\./g, '').replace('-', '').replace(/\_/g, '');
    } catch (err) {
      return { [CPFModel.CPF]: true, description: 'Can not replace' };
    }

    if (_cpf === '') {
      return { [CPFModel.CPF]: true, description: 'Null' };
    }

    if (_cpf.length !== 11) {
      return { [CPFModel.CPF]: true, description: 'Invalid size' };
    }

    // Algorithm to check CPF
    for (let i = 1; i <= 9; i++) {
      sum = sum + parseInt(_cpf.substring(i - 1, i), 10) * (11 - i);
    }
    rest = (sum * 10) % 11;
    if ((rest === 10) || (rest === 11)) {
      rest = 0;
    }
    if (rest !== parseInt(_cpf.substring(9, 10), 10)) {
      return { [CPFModel.CPF]: true, description: 'Invalid Cpf' };
    }
    sum = 0;
    for (let i = 1; i <= 10; i++) {
      sum = sum + parseInt(_cpf.substring(i - 1, i), 10) * (12 - i);
    }
    rest = (sum * 10) % 11;
    if ((rest === 10) || (rest === 11)) {
      rest = 0;
    }
    if (rest !== parseInt(_cpf.substring(10, 11), 10)) {
      return { [CPFModel.CPF]: true, description: 'Invalid Cpf' };
    }
    return null;
  }

  getMaskRule(): (string | RegExp)[] | Function | boolean {
    return this.cpfMask;
  }
  getValidatorsName(): string {
    return CPFModel.CPF;
  }
  getValidatorsErrorDescription(): string {
    return CPFModel.CPF_ERROR_DESCRIPTION;
  }
  getValidatorsRule(): ValidatorFn {
    return CPFModel.CPFValidation;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input/rules/implementations/cpf.model.ts